/**
 * Service pour gérer les demandes de RIB
 */

import { useState } from 'react';

const RIB_REQUEST_EMAIL_URL =
    "https://script.google.com/macros/s/AKfycbwITSBMRs8UF6w_feDDn3CJYBbMlplC_MJWvSbTzq6zrETvOPY6ajey76R_FvG6fVGl/exec";

export interface RibRequestParams {
    guestNames?: string;
    amount?: string;
    pageOrigin: string;
    email?: string; // Email optionnel pour recevoir le RIB
}



/**
 * Hook personnalisé pour gérer la demande de RIB
 * @returns Object contenant l'état et la fonction pour demander le RIB
 */
export const useRibRequest = () => {
    const [ribRequested, setRibRequested] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const requestRib = async (params: RibRequestParams) => {
        setIsLoading(true);
        setError(null);

        try {
            const payload = new FormData();
            payload.append("pageOrigin", params.pageOrigin);
            payload.append("timestamp", new Date().toLocaleString('fr-FR'));

            if (params.email) {
                payload.append("email", params.email);
            }
            if (params.guestNames) {
                payload.append("guestNames", params.guestNames);
            }
            if (params.amount) {
                payload.append("amount", params.amount);
            }

            try {
                await fetch(RIB_REQUEST_EMAIL_URL, {
                    method: "POST",
                    body: payload,
                });
            } catch (err) {
                console.error("Erreur lors de l'envoi de la notification RIB:", err);
                throw err;
            }
            setRibRequested(true);
        } catch (err) {
            setError("Une erreur est survenue lors de l'envoi de la demande");
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    const reset = () => {
        setRibRequested(false);
        setError(null);
    };

    return {
        ribRequested,
        isLoading,
        error,
        requestRib,
        reset,
    };
};